module.exports = __webpack_public_path__ + "img/kid-item1.a5d16026.png";